import { createApp } from 'vue'
import App from './App.vue'
import './CSS/styles.css'

createApp(App).mount('#app')
